import { SnackBar } from '@common/Snackbars/Snackbar';

export const onSuccessShow = (message: string) => SnackBar('success', message);
